const {h, render, Component} = require('preact');
const OrderStatusContainer = require('../../containers/status/order_status')

class OrderView extends Component {
  constructor(props) {
    super(props);
  };

  render() {
    let order = this.props.order;
    if(order){
      return (
        <td className="order-data-cell ch-bdr-prim ca-bdr-prim" width="50%" key={order.id} dealId={order.deal.id} onClick={this.props.orderDetails} data-bhw="web2018_order_summary">
          <table className="cell-table">
            <tr className="cell-row">
              <td className="image cell-column">
                <img src={order.deal.largeImageUrl} alt={"Deal Image" + order.merchant.name} />
              </td>
              <td className="order-info cell-column">
                <p className="b title"> {order.merchant.name}</p>
                <p className="description">{order.deal.title}</p>
                <OrderStatusContainer order={order} />
              </td>
            </tr>
          </table>
        </td>
    )
  }
  return(<td></td>)
  }
}
module.exports = OrderView
